import React, { useEffect, useState } from "react";

const LOGO = "/brand/logo.png";

const links = [
  { id: "work", label: "Work" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact Us" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jump = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#fdfbf7]/85 backdrop-blur-md border-b border-black"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 group"
        >
          <img
            src={LOGO}
            alt="Big Bear Studios"
            className="w-8 h-8 object-contain"
          />
          <span className="font-display tracking-tight text-[14px] sm:text-[15px] uppercase">
            Big Bear Studios<span className="text-[#FF4D00]">.</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => jump(l.id)}
              className="font-grotesk text-[13px] uppercase tracking-[0.18em] hover:text-[#FF4D00] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-cta"
          onClick={() => jump("contact")}
          className="hidden sm:inline-flex items-center gap-1.5 bg-black text-[#fdfbf7] px-4 h-10 font-grotesk text-[12px] uppercase tracking-[0.18em] hover:bg-[#FF4D00] transition-colors"
        >
          Work with us ↗
        </button>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center w-10 h-10 border border-black"
          aria-label="Menu"
        >
          <span className="font-mono text-[11px] uppercase tracking-wider">
            {open ? "Close" : "Menu"}
          </span>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black bg-[#fdfbf7]">
          <div className="max-w-[1480px] mx-auto px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => jump(l.id)}
                className="text-left font-display uppercase text-2xl tracking-tight hover:text-[#FF4D00]"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => jump("contact")}
              className="inline-flex items-center justify-between bg-black text-[#fdfbf7] px-4 h-12 font-grotesk text-[12px] uppercase tracking-[0.18em]"
            >
              <span>Work with us</span>
              <span>↗</span>
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
